import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaitoshirditaxifare() {



const cardData = {
  keyword: " Navi Mumbai to Shirdi Taxi Fare",

headingDescription:
  "Omshree Cab offers reliable and affordable Navi Mumbai to Shirdi taxi fare services for travelers planning a comfortable pilgrimage or leisure trip to the sacred town of Shirdi. Shirdi is one of the most visited spiritual destinations in Maharashtra and is famous for the revered Shirdi Sai Baba Temple, attracting millions of devotees every year. Whether you are planning a family pilgrimage, group tour, weekend trip, or religious journey, our taxi service ensures a safe, smooth, and convenient ride with experienced drivers and well-maintained vehicles. The distance from Navi Mumbai to Shirdi is approximately 240–250 km and the journey usually takes around 4 to 5 hours via NH160 depending on traffic conditions.",

topPlaces: [
  {
    title: "Shirdi Sai Baba Temple",
    description:
      "Shirdi Sai Baba Temple is the main spiritual attraction in Shirdi and one of the most visited pilgrimage destinations in India. Devotees from across the country travel here to seek blessings from Sai Baba, whose teachings emphasized faith, patience, and devotion. The temple complex includes the Samadhi Mandir where Sai Baba’s sacred tomb is located. Visitors participate in daily aartis, darshan, and spiritual rituals conducted throughout the day. The peaceful atmosphere and devotional energy make it a deeply meaningful place for pilgrims. Travelers arriving from Navi Mumbai by taxi can comfortably visit the temple and experience the spiritual environment of this holy shrine."
  },
  {
    title: "Dwarkamai",
    description:
      "Dwarkamai is a sacred mosque in Shirdi where Sai Baba spent many years of his life guiding and blessing devotees. The structure is simple yet holds immense spiritual importance for followers of Sai Baba. Inside the mosque visitors can see the sacred dhuni or eternal fire that Sai Baba kept burning. Devotees often sit here in silence, pray, and reflect on Baba’s teachings of kindness and unity. The site represents the harmony of religions and spiritual faith that Sai Baba promoted during his lifetime. A comfortable taxi ride from Navi Mumbai allows pilgrims to easily include Dwarkamai in their Shirdi temple visit."
  },
  {
    title: "Chavadi",
    description:
      "Chavadi is another important religious site associated with Sai Baba in Shirdi. Historically, Sai Baba used to sleep at Chavadi every alternate night during the later years of his life. Even today, a ceremonial procession known as the Chavadi Procession is conducted on Thursday evenings, recreating the traditional route taken by Sai Baba. Devotees gather here to witness this spiritual event and experience the historic significance of the place. Visiting Chavadi gives pilgrims a deeper understanding of Sai Baba’s life and traditions followed in Shirdi."
  },
  {
    title: "Gurusthan",
    description:
      "Gurusthan is believed to be the place where Sai Baba was first seen sitting under a neem tree when he arrived in Shirdi as a young saint. The site holds great importance because devotees consider it the place where Sai Baba’s spiritual journey in Shirdi began. Today a shrine and temple structure stand here, and devotees come to offer prayers and light incense sticks. The neem tree at the site is believed to have sacred significance among Sai Baba followers. Travelers visiting Shirdi by taxi from Navi Mumbai can conveniently explore this historic and spiritual location."
  },
  {
    title: "Sai Heritage Village",
    description:
      "Sai Heritage Village is a cultural and devotional theme park in Shirdi that presents the life and teachings of Sai Baba through detailed statues and displays. The village recreates scenes from Sai Baba’s life and depicts the rural lifestyle of the time when he lived in Shirdi. Visitors can walk through the exhibits to learn about Sai Baba’s miracles, compassion, and service to humanity. The attraction is both educational and spiritually inspiring for families and devotees. Travelers arriving from Navi Mumbai often visit this place to gain deeper insight into Sai Baba’s life."
  },
  {
    title: "Khandoba Temple",
    description:
      "Khandoba Temple is one of the oldest temples in Shirdi and holds historical importance in Sai Baba’s life. It is believed that when Sai Baba first arrived in Shirdi, the temple priest Mhalsapati greeted him with the words 'Ya Sai', which later became the name by which Baba was known. The temple is dedicated to Lord Khandoba and continues to attract devotees who visit Shirdi. The peaceful environment and spiritual significance make it an important stop during the Shirdi pilgrimage."
  },
  {
    title: "Lendi Baug",
    description:
      "Lendi Baug is a beautiful garden located near the Sai Baba Temple complex where Sai Baba used to visit daily for meditation and quiet reflection. The garden contains a sacred lamp known as Nanda Deep that has been burning continuously for many years. Visitors walk through the pathways, sit in silence, and enjoy the calm surroundings of the garden. The peaceful greenery provides a relaxing break from the busy temple area. Pilgrims visiting Shirdi by taxi from Navi Mumbai often stop here to experience its spiritual tranquility."
  },
  {
    title: "Shani Shingnapur",
    description:
      "Shani Shingnapur is a famous temple village located about 70 km from Shirdi and is dedicated to Lord Shani, the Hindu deity associated with justice and karma. The temple is unique because the idol of Lord Shani is placed in the open without a traditional temple structure above it. The village is also known for houses without doors, reflecting the belief that Lord Shani protects the residents from theft and misfortune. Many travelers visiting Shirdi include Shani Shingnapur in their itinerary. A taxi journey from Navi Mumbai makes it convenient to visit both destinations in a single trip."
  },
  {
    title: "Wet N Joy Water Park",
    description:
      "Wet N Joy Water Park is a popular recreational destination near Shirdi offering a wide range of water rides, slides, and family-friendly attractions. The park provides entertainment for visitors who want to combine their pilgrimage trip with fun activities. Families and children especially enjoy the wave pools, lazy rivers, and thrilling slides available in the park. The facility also includes restaurants and relaxation areas where visitors can spend a full day enjoying leisure activities."
  },
  {
    title: "Sai Teerth Theme Park",
    description:
      "Sai Teerth Theme Park is a modern devotional theme park in Shirdi that combines spirituality with entertainment and technology. The park features immersive attractions such as animated shows, 5D theatre experiences, and cultural exhibits based on the life and teachings of Sai Baba. Visitors can explore different sections that showcase spiritual stories and historical events related to Sai Baba’s life. The park is popular among families and tourists looking for a unique spiritual experience along with entertainment. Travelers arriving from Navi Mumbai by taxi can conveniently include this attraction during their Shirdi visit."
  }
],



services: [
{
name: "Navi Mumbai to Shirdi Cab",
description: "Navi Mumbai to Shirdi cab service provides comfortable and reliable transportation for devotees traveling to the holy town of Shirdi. This route is popular among pilgrims visiting the famous Sai Baba Temple. Our fleet includes AC sedans, SUVs, and spacious MPV vehicles designed for long-distance travel. Professional drivers ensure safe driving along the highway and punctual pickup services across Navi Mumbai. Pickup is available from homes, offices, hotels, railway stations, and airport locations. Comfortable seating and luggage space ensure relaxed travel for families and groups. Ideal for pilgrimage trips, family travel, and spiritual journeys."
},
{
name: "Navi Mumbai to Shirdi Taxi",
description: "Navi Mumbai to Shirdi taxi service offers dependable transportation for travelers visiting the sacred Sai Baba Temple in Shirdi. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup services and safe travel throughout the route. Air-conditioned vehicles ensure relaxed travel during the journey. Ideal for pilgrims, tourists, and families planning temple visits."
},
{
name: "Navi Mumbai to Shirdi Cab Service",
description: "Navi Mumbai to Shirdi cab service provides convenient transportation for passengers planning spiritual visits to Shirdi. Vehicles are well maintained and suitable for highway journeys with comfortable seating and luggage capacity. Professional drivers ensure punctual pickup services and safe driving throughout the journey."
},
{
name: "Navi Mumbai to Shirdi Taxi Service",
description: "Navi Mumbai to Shirdi taxi service offers reliable road transportation for devotees traveling to the famous Sai Baba temple. Vehicles provide comfortable seating and smooth ride quality suitable for long-distance travel. Professional drivers ensure timely pickups and safe travel along the highway route."
},
{
name: "Cab from Navi Mumbai to Shirdi",
description: "Cab from Navi Mumbai to Shirdi provides convenient intercity transportation for pilgrims visiting Sai Baba Temple. Vehicles offer comfortable seating and reliable ride performance suitable for highway travel. Professional drivers ensure punctual pickup services across Navi Mumbai."
},
{
name: "Taxi from Navi Mumbai to Shirdi",
description: "Taxi from Navi Mumbai to Shirdi offers comfortable transportation for passengers traveling to the holy town of Shirdi. Vehicles provide air-conditioned interiors and smooth ride quality suitable for long-distance travel. Professional drivers ensure punctual pickup services and safe driving throughout the route."
},
{
name: "Navi Mumbai to Shirdi Cab Booking",
description: "Navi Mumbai to Shirdi cab booking allows passengers to reserve vehicles easily for temple visits and pilgrimage travel. Online and phone booking options provide quick confirmation and flexible scheduling. Vehicles provide comfortable seating and reliable highway performance."
},
{
name: "Navi Mumbai to Shirdi Taxi Booking Online",
description: "Navi Mumbai to Shirdi taxi booking online provides fast digital reservations for travelers planning Shirdi temple visits. Passengers can schedule rides online and receive instant booking confirmation. Vehicles offer comfortable seating and smooth ride quality suitable for the journey."
},
{
name: "Navi Mumbai to Shirdi Taxi Fare",
description: "Navi Mumbai to Shirdi taxi fare services provide transparent pricing options depending on vehicle category and travel distance. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort and group size."
},
{
name: "Navi Mumbai to Shirdi Cab Price",
description: "Navi Mumbai to Shirdi cab price options provide clear fare estimates for pilgrimage travel. Pricing depends on vehicle type, trip duration, and travel distance. Transparent pricing helps travelers plan their travel budget easily."
},
{
name: "Navi Mumbai to Shirdi One Way Cab",
description: "Navi Mumbai to Shirdi one way cab service provides economical transportation without return charges. Vehicles offer comfortable seating and smooth highway performance suitable for long-distance travel."
},
{
name: "Navi Mumbai to Shirdi Round Trip Taxi",
description: "Navi Mumbai to Shirdi round trip taxi service provides convenient transportation for pilgrims planning return journeys after temple darshan. Vehicles remain available as per travel schedule ensuring comfortable travel in both directions."
},
{
name: "Sai Baba Temple Cab Navi Mumbai",
description: "Sai Baba temple cab Navi Mumbai service provides direct transportation for devotees traveling to Shirdi for darshan. Vehicles provide comfortable seating and reliable highway performance suitable for pilgrimage travel."
},
{
name: "Innova Cab Navi Mumbai Shirdi",
description: "Innova cab Navi Mumbai Shirdi service provides spacious MPV transportation ideal for families and groups traveling together for temple visits. Toyota Innova vehicles offer comfortable seating and smooth highway performance suitable for long-distance journeys."
}
],

tableData: [
["Navi Mumbai to Shirdi Cab","Navi Mumbai to Shirdi Taxi"],
["Navi Mumbai to Shirdi Cab Service","Navi Mumbai to Shirdi Taxi Service"],
["Cab from Navi Mumbai to Shirdi","Taxi from Navi Mumbai to Shirdi"],
["Navi Mumbai to Shirdi Cab Booking","Navi Mumbai to Shirdi Taxi Booking Online"],
["Navi Mumbai to Shirdi Taxi Fare","Navi Mumbai to Shirdi Cab Price"],
["Navi Mumbai to Shirdi One Way Cab","Navi Mumbai to Shirdi Round Trip Taxi"],
["Sai Baba Temple Cab Navi Mumbai","Innova Cab Navi Mumbai Shirdi"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving from Navi Mumbai to Shirdi Temple. They are familiar with the highway routes and temple travel conditions ensuring a safe and comfortable spiritual journey."
  },
  {
    WhyChooseheading: "Transparent Taxi Fare",
    WhyChoosedescription: "Omshree Cabs provides transparent taxi fare for Navi Mumbai to Shirdi cab bookings. Customers receive clear details about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Our Navi Mumbai to Shirdi taxi service operates 24 hours a day. Whether you want to start early morning for Sai Baba darshan or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure passengers enjoy a comfortable pilgrimage travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way taxi bookings, round trips, and same-day return packages from Navi Mumbai to Shirdi."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group pilgrims."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business locations anywhere in Navi Mumbai for a smooth start to your Shirdi pilgrimage journey."
  },
  {
    WhyChooseheading: "Trusted Shirdi Taxi Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many devotees traveling from Navi Mumbai to Shirdi thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide taxi service from Navi Mumbai to Shirdi?", answer: "Yes, Omshree Cabs provides reliable taxi services from Navi Mumbai to Shirdi for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai to Shirdi?", answer: "The distance from Navi Mumbai to Shirdi is approximately 240 km and the journey usually takes around 5 to 6 hours depending on traffic and road conditions." },
  { question: "What is the taxi fare from Navi Mumbai to Shirdi?", answer: "Taxi fare from Navi Mumbai to Shirdi depends on the vehicle type, but sedan taxi fares usually start around ₹3500 to ₹4500 for one-way travel." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the taxi service available 24 hours?", answer: "Yes, our Navi Mumbai to Shirdi taxi service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and festival seasons when many devotees visit Shirdi." },
  { question: "Do you provide same-day return packages?", answer: "Yes, Omshree Cabs offers same-day return taxi packages from Navi Mumbai to Shirdi." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "We booked Omshree Cabs for our Navi Mumbai to Shirdi trip. The driver was punctual and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Patil",
    feedback:
      "Excellent taxi service for Shirdi travel. Clean vehicle, polite driver, and smooth journey.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides reliable taxi services from Navi Mumbai to Shirdi. Book one-way or round-trip cabs, including Innova, for Sai Baba temple visits, pilgrimages, and outstation travel.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": [
    "Navi Mumbai to Shirdi Cab",
    "Outstation Taxi Service",
    "Pilgrimage Taxi",
    "Innova Taxi Service",
    "Sai Baba Temple Cab"
  ]
};







  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai to Shirdi Taxi Fare | Omshree Cab</title>
  <meta
    name="description"
    content="Book a cab from Navi Mumbai to Shirdi with Omshree Cab. One-way and round-trip taxi services available, including Innova for comfortable travel to Sai Baba temple and Shirdi pilgrimage."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitoshirditaxifare;